import React from 'react';
import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import {
  DESKTOP_NAVIGATION_MENU_WIDTH,
  DESKTOP_NAVIGATION_MENU_RESPONSIVE_WIDTH,
} from '../../../../constants/Layout';

import ProfileInfo from './ProfileInfo';
import Menu from '../../navigationMenu/navigationMenu';
const useStyles = makeStyles((theme) => ({
  drawer: {
    [theme.breakpoints.down('lg')]: {
      width: DESKTOP_NAVIGATION_MENU_RESPONSIVE_WIDTH,
    },
    width: DESKTOP_NAVIGATION_MENU_WIDTH,
    backgroundColor: 'white',
    overflowY: 'auto',
    height: 'auto',
  },
}));

const NavigationMenu = () => {
  const classes = useStyles();

  return (
    <Paper elevation={3} className={classes.drawer}>
      <div>
        <ProfileInfo />
        <Menu />
      </div>
    </Paper>
  );
};

export default NavigationMenu;
